import { Button } from "@components/ui/Button"
import { TabControl } from "@components/ui/TabControl"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useDonateCampaignContext } from "./donate-campaign"
import { useState } from "react"
import { useFerve } from "@features/ferve/FerveProvider"
import { alerts } from "@features/alerts/alerts"
import { flyingCarpet } from "@features/flying-carpet/useFlyingCarpet"

export const meta: BlockMeta = {
  title: "Donation Page",
  description: "A large section to drive quick donations.",
}

export default defineBlock("tickets/donate-campaign-page", (props) => {
  const {
    amount,
    setAmount,
    customAmount,
    setCustomAmount,
    ferveHash,
    working,
    setWorking,
    ferveItemHash,
    fervePriceTypeHash,
  } = useDonateCampaignContext()
  const ferve = useFerve()

  const startCheckout = async () => {
    setWorking(true)

    if (!ferveItemHash || !fervePriceTypeHash) {
      const total = amount === "custom" ? customAmount : amount
      if (!total || total === 0) {
        alerts.displayAlert({ title: "Oops...", description: "Please select a donation amount" })
        setWorking(false)
        return
      }

      const pricing = await ferve.cart.getPricing(ferveHash!)
      const price = pricing.find((p) => p.price === -1 || p.label === "Other")
      if (!price) {
        alerts.displayAlert({ title: "Oops...", description: "Donation pricing not found" })
        setWorking(false)
        return
      }
      try {
        await ferve.cart.addItemsToCart(ferveHash!, [
          {
            quantity: total * 100,
            type: {
              priceTypeHash: price.priceTypeHash,
            },
          },
        ])
      } catch (err) {
        alerts.displayAlert({ title: "Oops...", description: (err as Error)?.message })
        setWorking(false)
        return
      }
    } else {
      try {
        await ferve.cart.addItemsToCart(ferveItemHash!, [
          {
            quantity: 1,
            type: {
              priceTypeHash: fervePriceTypeHash,
            },
          },
        ])
      } catch (err) {
        alerts.displayAlert({ title: "Oops...", description: (err as Error)?.message })
        setWorking(false)
        return
      }
    }
    setWorking(false)
    flyingCarpet.launch("cart")
  }

  return (
    <div className="w-full flex flex-col gap-5">
      {env.admin && (
        <div className="flex items-center justify-center p-4">
          {/* Tab control shown as a preview in admin */}
          <Button shape="branded" variant="primary">
            <EditableText as="div" store="tabTitle" defaultValue="Enter a title" />
          </Button>
        </div>
      )}
      <p className="type-label-caps block mt-4">
        <EditableText
          as="span"
          store="intro-text"
          placeholder="SELECT AMOUNT you wish to donate:"
          defaultValue="SELECT AMOUNT you wish to donate:"
        />
      </p>
      <div className={cn(!env.admin && "grid grid-cols-1 md:grid-cols-2 gap-5")}>
        <InnerBlocks allowedBlocks={["tickets/donate-campaign-item"]} adminClassName="mx-auto grid grid-cols-1 gap-5" />
      </div>
      <div className="py-5">
        <div className="flex md:col-span-10 md:col-start-2 md:justify-end">
          <Button shape="branded" variant="primary" loading={working} onClick={() => startCheckout()}>
            <EditableText
              as="span"
              store="checkout-button"
              defaultValue="Proceed to Checkout"
              placeholder="Proceed to Checkout"
            />
          </Button>
        </div>
      </div>
    </div>
  )
})
